<template>
    <v-alert
        v-if="noPhoneSet"
        color="accent" dense text v-ripple
        class="pointer" border="left"
        icon="mdi-phone-alert-outline"
        @click="goToEditPhone" dismissible
    >
        {{ $t('common.config_your_phone') }}
        <template v-slot:close="{ toggle }">
            <v-btn icon color="accent" dark @click.stop="closeAlert(toggle)">
                <v-icon>mdi-close-circle</v-icon>
            </v-btn>
        </template>
    </v-alert>
</template>

<script>
export default {
    name: "NoPhoneSet",
    computed: {
        noPhoneSet(vm = this) {
            return !vm.account?.phone && (!localStorage.builder_noShowRequiredPhoneAgain || localStorage.builder_noShowRequiredPhoneAgain === 'false')
        },
    },
    methods: {
        goToEditPhone() {
            const vm = this
            vm.$router.push({name: `${vm.accountType}.profile.edit`, params: {mode: 'BasicInfoStepper'}})
        },
        closeAlert(dismiss) {
            localStorage.builder_noShowRequiredPhoneAgain = true
            dismiss()
        },
    }
}
</script>

<style scoped>

</style>